import React, { Fragment, useEffect } from "react";
import config from "commons/config";
import callAPI from "commons/callAPI";
import { getSessionStorage, setSessionStorage } from "util/storageUtil";
import { refactorSubMenus } from "containers/header/config";

const LoadHeaderAndFooter = (props) => {
  useEffect(() => {
    const cachedHeader = getSessionStorage("header");
    const cachedFooter = getSessionStorage("footer");

    if (cachedHeader && cachedFooter) {
      // Cache-first — unblock header/footer render immediately.
      // The Header component listens for "headerDataReady" to re-read sessionStorage.
      window.dispatchEvent(new CustomEvent("headerDataReady"));
      props.setIsHeaderAndFooterLoaded(true);
    }

    // Always refresh in the background to pick up CMS changes.
    Promise.all([getHeaderData(), getFooterData()]).finally(() => {
      // Notify Header to re-read fresh data from sessionStorage.
      window.dispatchEvent(new CustomEvent("headerDataReady"));
      if (!cachedHeader || !cachedFooter) {
        props.setIsHeaderAndFooterLoaded(true);
      }
    });
  }, []);

  const getHeaderData = async () => {
    try {
      let apiURL = config.api.navbar;
      let apiResponse = await callAPI.get(apiURL);
      let regResponse = await apiResponse.json();

      if (apiResponse.status === 200 && regResponse.length > 0) {
        const newHeaderData = refactorSubMenus(regResponse);
        setSessionStorage("header", newHeaderData);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getFooterData = async () => {
    try {
      let apiURL = config.api.footer;
      let apiResponse = await callAPI.get(apiURL);
      let regResponse = await apiResponse.json();
      if (apiResponse.status === 200) {
        const data = regResponse?.data[0] || {};
        setSessionStorage("footer", data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  return <Fragment>{props.children}</Fragment>;
};

export default LoadHeaderAndFooter;
